// PERMANENT FLAGS
export const STAFF = 'staff'

// TEMP FEATURE FLAGS
export const PAGE_LOCKING = 'page-locking'
export const CLASSIC_DOC_TYPE = 'classic-doc-type'
// flag to route search traffic to nido. it will get more advanced incrementally
export const ADVANCED_SEARCH = 'advanced-search'
